import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'

export const mergeTabsSettings = (current: IFlexLayout, user: IFlexLayout) => {
  const tabs = {}
  if (user.items) {
    user.items.forEach((el) => {
      if (el.isFlexLayout && el.layoutSet) {
        mergeTabsSettings(current, el.layoutSet)
      } else {
        if (
          el.widgets &&
          el.widgets[0] &&
          el.widgets[0].id &&
          (el.widgets[0].id.indexOf('tab-buttons') > -1 ||
            el.widgets[0].id.indexOf('partner-selector') > -1)
        ) {
          tabs[el.name || 'par'] = el.customWidgetSettings
        }
      }
    })
  }
  applyTabsSetting(current, tabs)
}

const applyTabsSetting = (current: IFlexLayout, settings: any) => {
  if (current.items) {
    current.items.forEach((el) => {
      if (el.isFlexLayout && el.layoutSet) {
        applyTabsSetting(el.layoutSet, settings)
      } else {
        if (
          el.widgets &&
          el.widgets[0] &&
          el.widgets[0].id &&
          (el.widgets[0].id.indexOf('tab-buttons') > -1 ||
            el.widgets[0].id.indexOf('partner-selector') > -1)
        ) {
          el.customWidgetSettings = settings[el.name || 'par']
        }
      }
    })
  }
}
